{
  "dss": {
    "button": {
      "back": "Voltar",
      "cancel": "Cancelar",
      "close": "Fechar",
      "confirmDelete": "Sim, apagar",
      "continue": "Continuar",
      "logout": "Sair",
      "passwordReset": "Redefinir palavra-passe",
      "save": "Guardar",
      "verify": "Verificar"
    },
    "error": {
      "403": "Não tem acesso a esta página.",
      "404": "Esta página não existe.",
      "generic": "Ocorreu um erro. Por favor, tente novamente mais tarde.",
      "throttling": "Demasiadas tentativas. Esta operação está bloqueada durante algum tempo.",
      "title": "Erro",
      "title403": "Acesso negado",
      "title404": "Não encontrado"
    },
    "footer": {
      "imprint": "Sobre nós",
      "legalEntity": "Andreas Stihl, S.A.  R.C.Emp. Ed.3-P.0-Lj.2  2710-693 Sintra, Portugal",
      "privacy": "Proteção de Dados",
      "terms": "Condições gerais"
    },
    "label": {
      "CRMAccountNumber": "Nº da conta CRM",
      "contact": "Contacto",
      "email": "Email",
      "faq": "FAQ",
      "female": "Sra.",
      "firstname": "Primeiro nome",
      "help": "Ajuda",
      "language": "Idioma",
      "lastname": "Último nome",
      "male": "Sr.",
      "needHelp": "Preciso de ajuda?",
      "newPassword": "Nova palavra-passe",
      "newPassword2": "Confirmar nova palavra-passe",
      "oldPassword": "Palavra-passe atual",
      "organization": "Concessionário",
      "password": "Palavra-passe",
      "required": "necessário",
      "salutation": "Saudação",
      "select": "Por favor seleccione"
    },
    "lang": {
      "pt": "Português",
      "pt-BR": "Brasil Português"
    },
    "link": {
      "contact": "https://support.stihl.com/pt-PT/websso-contact/",
      "faq": "https://support.stihl.com/pt-PT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Confirmar Registo",
        "wait": "Por favor aguarde para completar a confirmação de conta."
      },
      "otp": {
        "btnResend": "Reenviar e-mail com código de verificação",
        "msg": {
          "invalidOTP": "A palavra-passe única introduzida é inválida.",
          "resendFail": "Falha em reenviar o código. Por favor, tente de novo mais tarde."
        },
        "spamDetail": "Verifique a sua caixa de entrada e pasta de spam para um e-mail do STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Não recebeu um e-mail?",
        "subtitle": "Para continuar, precisa de verificar o seu endereço de correio electrónico.",
        "title": "Verifique a sua conta de utilizador",
        "txtVerifyMail": "Por favor introduza o novo código de verificação que enviámos para o seu endereço de correio electrónico {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Não há nada a actualizar.",
          "updateError": "Falha na actualização de dados pessoais.",
          "updated": "Os dados pessoais foram actualizados.",
          "userLoadErr": "Erro ao carregar dados de utilizador. Por favor, tente novamente mais tarde."
        },
        "secOrganization": "Organização",
        "secPersonal": "Pessoal",
        "secSettings": "Configurações preferidas",
        "title": "Informação pessoal"
      },
      "postPwSet": {
        "info": "Pode agora utilizar a sua nova palavra-passe.",
        "link_name": "Continue to Self-Service",
        "link_url": "/user/ui/",
        "title": "A sua palavra-passe foi alterada"
      },
      "resetPW": {
        "title": "Redefinir a sua palavra-passe"
      },
      "security": {
        "2fa": {
          "availableMethods": "Métodos de 2FA disponíveis:",
          "info": "A autenticação de dois fatores (2FA) é um recurso de segurança que adiciona uma camada extra de proteção à sua conta. Ela exige que você use dois métodos para fazer login, em vez de apenas um nome de usuário e senha.",
          "method": {
            "email": "E-mail",
            "emailDesc": "Receba códigos únicos enviados por e-mail para concluir as solicitações de autenticação.",
            "oath": {
              "add": {
                "button": "Registrar Aplicativo de Autenticação"
              }
            }
          }
        },
        "authenticator": "Aplicação autenticadora",
        "infoFederatedAccount": "Esta conta é gerida pelo fornecedor de identidade da sua organização, pelo que a palavra-passe não pode ser alterada aqui. Para alterar a sua palavra-passe, inicie sessão através da página de login da sua organização ou contacte o seu administrador de TI.",
        "lastUse": "Última utilização em {0}.",
        "msg": {
          "invalidPassword": "Palavra-passe actual inválida fornecida.",
          "passwordAlreadyUsed": "Não é possível reutilizar as últimas 5 palavras-passe.",
          "pwUpdateError": "Ocorreu um erro ao tentar alterar a palavra-passe.",
          "pwUpdated": "A palavra-passe foi alterada."
        },
        "noDevice": "Não configurado",
        "oathAdd": {
          "appInfo": "As aplicações autenticadoras como {0}, {1}, etc. geram palavras-passe de utilização única que são utilizadas como um segundo fator durante o login.",
          "badCode": "Código inválido, por favor tente novamente.",
          "error": "Ocorreu um erro ao tentar registar o dispositivo autenticador.",
          "headScan": "1. Escaneie o código QR com a sua aplicação autenticadora",
          "headVerify": "2. Verifique o código",
          "infoKey": "chave de configuração",
          "infoKeyTitle": "O seu segredo de dois fatores",
          "infoScanBottom": "Não é possível verificar? Pode utilizar o {0} para configurar manualmente a sua aplicação autenticadora.",
          "infoVerify": "Introduza o código gerado pela sua aplicação autenticadora.",
          "success": "O seu dispositivo autenticador foi registado. Agora pode utilizá-lo para entrar.",
          "title": "Registe o seu dispositivo de autenticação de dois fatores"
        },
        "oathDelete": {
          "error": "Ocorreu um erro ao tentar eliminar o dispositivo autenticador.",
          "success": "O dispositivo autenticador foi eliminado."
        },
        "passkeys": {
          "about": {
            "info1": "As chaves de acesso são pares de chaves criptográficas (uma chave pública e uma privada) armazenadas em um autenticador controlado por você. O autenticador pode provar que você está presente e autorizado a usar a chave de acesso. Os autenticadores verificam a autorização com um PIN, senha, biometria ou senha do dispositivo, dependendo das capacidades e configurações do autenticador. Os autenticadores podem assumir várias formas, como um iPhone ou dispositivo Android, Windows Hello, uma chave de segurança de hardware FIDO2 ou um gerenciador de senhas.",
            "info2": "Ao fazer login no STIHL com uma chave de acesso, seu autenticador usa criptografia de chave pública para provar sua identidade ao STIHL sem nunca enviar a chave de acesso. As chaves de acesso estão vinculadas a um domínio de site, como stihl-sso.com, e requerem uma conexão segura, o que significa que o navegador rejeitará a autenticação em um site de phishing semelhante. Essas propriedades tornam as chaves de acesso altamente resistentes ao phishing e muito mais difíceis de atacar do que SMS ou 2FA TOTP, que podem ser vulneráveis ao phishing.",
            "info3": "Os serviços de chaves de acesso baseados em nuvem permitem que as chaves sejam sincronizadas entre dispositivos (como dispositivos Apple, Android ou gerenciadores de senhas) para torná-las acessíveis a partir de mais locais e menos propensas a serem perdidas. Depois que você configurar uma chave de acesso sincronizada em um dispositivo, essa chave estará disponível em vários dispositivos que usam o mesmo serviço. Por exemplo, se você registrar uma chave com sua conta do iCloud usando o Touch ID do seu MacBook, poderá usar essa chave com seu rosto, impressão digital, PIN ou senha do dispositivo de forma intercambiável em vários dispositivos vinculados à mesma conta iCloud.",
            "title": "Sobre as Chaves de Acesso"
          },
          "add": {
            "button": "Adicionar Nova Chave de Acesso",
            "error": "Ocorreu um erro ao tentar adicionar uma nova chave de acesso.",
            "success": "Uma nova chave de acesso foi adicionada."
          },
          "delete": {
            "button": "Excluir Chave de Acesso",
            "error": "Ocorreu um erro ao tentar excluir essa chave de acesso.",
            "success": "A chave de acesso foi excluída."
          },
          "edit": {
            "error": "Ocorreu um erro ao tentar salvar o nome da chave de acesso.",
            "name": "Nome da Chave de Acesso",
            "success": "O nome da chave foi atualizado.",
            "title": "Dê um nome à sua chave de acesso para diferenciá-la de outras chaves de acesso"
          },
          "info": "A chave de acesso é uma alternativa simples e segura às senhas, que valida sua identidade usando toque, reconhecimento facial, senha do dispositivo ou um PIN.",
          "none": "Nenhuma chave de acesso configurada.",
          "reallyDelete": "Tem certeza de que deseja excluir a chave de acesso?",
          "registeredPasskeys": "Suas chaves de acesso registradas:",
          "title": "Chaves de Acesso"
        },
        "reallyDeleteDevice": "Tem a certeza que pretende eliminar o dispositivo autenticador?",
        "secMFA": "Autenticação multifator",
        "secPwdChange": "MUDAR Palavra-passe",
        "title": "Login e segurança"
      },
      "setPW": {
        "acceptTC": "Por favor, confirme nossos {terms} e {privacy}.",
        "killSSO": "Invalidar todas as sessões activas",
        "msg": {
          "tokenExpired": "O link ou código da palavra-passe expirou. Por favor, siga a ligação para redefinir a sua palavra-passe: {link}."
        },
        "privacy": "Política de Privacidade",
        "terms": "Termos e Condições",
        "title": "Introduzir nova palavra-passe"
      }
    },
    "validations": {
      "hasDigit": "Deve conter dígito(s)",
      "hasLowercase": "Deve conter letra(s) minúscula(s)",
      "hasSpecial": "Deve conter carácter(es) especial(ais): {chars}",
      "hasUppercase": "Deve conter carácter(es) maiúsculo(s)",
      "invalidCharacters": "Contém caracteres inválidos",
      "maxLength": "Máximo de {max} caracteres permitidos",
      "minLength": "Mínimo de {min} caracteres necessários",
      "notSameAsEmail": "Muito semelhante ao endereço de e-mail",
      "onlyValidCharactersAllowed": "Apenas letras, números e espaços são permitidos.",
      "required": "Valor necessário",
      "sameAsPassword": "As palavras-passe não coincidem",
      "tcAccepted": "Por favor, confirme nossos termos e condições e política de privacidade.",
      "validEmail": "Endereço de e-mail inválido.",
      "validOTP": "Por favor introduza o código de verificação."
    }
  }
}
